import MyGamesLayout from '../components/MyGamesLayout'

import Games from './games'
import type { MyGamesPageType } from './types'

function GamesRoot(props: MyGamesPageType) {
  return (
    <MyGamesLayout>
      <Games {...props} />
    </MyGamesLayout>
  )
}

export default GamesRoot
